module.exports = __webpack_public_path__ + "img/gylogin.f9af1efa.png";